import { EmployeeExport } from '@models/employee/exporters/employee-export.model';
import { BulkExportMetaData } from '../../interfaces/bulk-export-meta-data';

export const BULK_EXPORT_META_DATA: BulkExportMetaData[] = [
    {
        routerLink: 'employees',
        name: 'reporting.data-export.reportMeta.employees.name',
        description: 'reporting.data-export.reportMeta.employees.description',
        // guide: 'Fill your existing employee information into the spreadsheet or format an export from another HRIS or Payroll software.',
        // templateLocation: '/assets/csv/bulk-employees.csv',
        exportModel: EmployeeExport,
    },
];
